import { network } from 'services/network';

const ENDPOINT = 'api/bo/project/getDataStories';

export const getDataStories = ({ filter, pageParam, projectId }, endpoint = ENDPOINT) => {
    const params = {
        filter: { filters: filter.filter.filters },
        paging: pageParam,
        projectId,
    };

    return network.post(endpoint, params).then((response) => {
        return response.data;
    });
};
